import React from 'react'; 
import ReactDOM from 'react-dom/client';  // Nota el cambio aquí
import { BrowserRouter as Router } from 'react-router-dom';  // Importa Router
import App from './App';  // Tu componente principal de la aplicación

// Usa createRoot en lugar de render
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Router> {/* Coloca Router aquí */}
    <App />
  </Router>
);
